import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";
import {PingPongOverflowText} from "@pg-mono/ping-pong-overflow-text";

import {HOME_MATCH_PREFERENCES_WIZARD_CONTENT} from "../../constants/preferences/home_match_preferences_wizard_content";

const {CHANGE} = HOME_MATCH_PREFERENCES_WIZARD_CONTENT.SUMMARY;

export interface IHomeMatchPreferencesWizardSummaryRowProps {
    label: string;
    onChange: () => void;
    overflow?: "ellipsis" | "pingpong";
    testId: string;
    value: string;
}

export const HomeMatchPreferencesWizardSummaryRow = (props: IHomeMatchPreferencesWizardSummaryRowProps) => {
    const {label, onChange, overflow, testId, value} = props;

    return (
        <div className={rowStyle}>
            <div className={rowTextStyle}>
                <Text className={labelStyle} color="var(--colors-gray-800)" preserveFontSize variant="info_txt_3">
                    {label}
                </Text>

                {value && overflow === "pingpong" && (
                    <PingPongOverflowText>
                        <Text className={apartmentValueStyle} color="var(--colors-secondary)" preserveFontSize variant="body_copy_2">
                            {value}
                        </Text>
                    </PingPongOverflowText>
                )}

                {value && overflow === "ellipsis" && (
                    <Text className={locationValueStyle} color="var(--colors-secondary)" preserveFontSize variant="body_copy_2">
                        {value}
                    </Text>
                )}

                {value && !overflow && (
                    <Text color="var(--colors-secondary)" preserveFontSize variant="body_copy_2">
                        {value}
                    </Text>
                )}
            </div>

            <Button className={changeButtonStyle} dataTestId={testId} onClick={onChange} textVariant="body_copy_2" type="button" variant="none_secondary">
                {CHANGE}
            </Button>
        </div>
    );
};

const rowStyle = css({
    alignItems: "center",
    display: "flex",
    gap: 2,
    justifyContent: "space-between"
});

const rowTextStyle = css({
    display: "flex",
    flex: "1 1 auto",
    flexDirection: "column",
    gap: 0.5,
    minWidth: 0
});

const locationValueStyle = css({
    lineClamp: 3,
    whiteSpace: "normal"
});

const apartmentValueStyle = css({
    whiteSpace: "nowrap"
});

const labelStyle = css({
    textTransform: "uppercase"
});

const changeButtonStyle = css({
    "&:hover": {
        color: "var(--colors-gray-800)"
    },
    borderWidth: 0,
    color: "var(--colors-gray-800)",
    flexShrink: 0,
    height: "auto",
    minWidth: 0,
    p: 0,
    textDecoration: "underline"
});
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";
import {PingPongOverflowText} from "@pg-mono/ping-pong-overflow-text";

import {HOME_MATCH_PREFERENCES_WIZARD_CONTENT} from "../../constants/preferences/home_match_preferences_wizard_content";

const {CHANGE} = HOME_MATCH_PREFERENCES_WIZARD_CONTENT.SUMMARY;

export interface IHomeMatchPreferencesWizardSummaryRowProps {
    label: string;
    onChange: () => void;
    overflow?: "ellipsis" | "pingpong";
    testId: string;
    value: string;
}

export const HomeMatchPreferencesWizardSummaryRow = (props: IHomeMatchPreferencesWizardSummaryRowProps) => {
    const {label, onChange, overflow, testId, value} = props;

    return (
        <div className={rowStyle}>
            <div className={rowTextStyle}>
                <Text className={labelStyle} color="var(--colors-gray-800)" preserveFontSize variant="info_txt_3">
                    {label}
                </Text>

                {value && overflow === "pingpong" && (
                    <PingPongOverflowText>
                        <Text className={apartmentValueStyle} color="var(--colors-secondary)" preserveFontSize variant="body_copy_2">
                            {value}
                        </Text>
                    </PingPongOverflowText>
                )}

                {value && overflow === "ellipsis" && (
                    <Text className={locationValueStyle} color="var(--colors-secondary)" preserveFontSize variant="body_copy_2">
                        {value}
                    </Text>
                )}

                {value && !overflow && (
                    <Text color="var(--colors-secondary)" preserveFontSize variant="body_copy_2">
                        {value}
                    </Text>
                )}
            </div>

            <Button className={changeButtonStyle} dataTestId={testId} onClick={onChange} textVariant="body_copy_2" type="button" variant="none_secondary">
                {CHANGE}
            </Button>
        </div>
    );
};

const rowStyle = css({
    alignItems: "center",
    display: "flex",
    gap: 2,
    justifyContent: "space-between"
});

const rowTextStyle = css({
    display: "flex",
    flex: "1 1 auto",
    flexDirection: "column",
    gap: 0.5,
    minWidth: 0
});

const locationValueStyle = css({
    lineClamp: 3,
    whiteSpace: "normal"
});

const apartmentValueStyle = css({
    whiteSpace: "nowrap"
});

const labelStyle = css({
    textTransform: "uppercase"
});

const changeButtonStyle = css({
    "&:hover": {
        color: "var(--colors-gray-800)"
    },
    borderWidth: 0,
    color: "var(--colors-gray-800)",
    flexShrink: 0,
    height: "auto",
    minWidth: 0,
    p: 0,
    textDecoration: "underline"
});
